import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { Banner } from './banner.store';
import { toPromise } from './toPromise';

export interface SellerSignUp {
  shop_name: string;
  email: string;
  phone_code: string;
  phone: string;
  storage_locations: Array<[]>;
  pickup_locations: Array<[]>;
  img: string;
  type: number;
}

export interface VerifyMobile {
  phone: string;
}

export interface VerifyOtp {
  otp: string;
}

export interface sellerResponse {
  status: number;
  data: sellerDetails;
}
export interface sellerDetails {
  id: number;
  user_id: number;
  shop_name: string;
  email: string;
  phone: number;
  phone_code: number;
  profile_photo: string;
  banner_photo: string;
  shop_url: string;
  shop_title: string;
  shop_body: string;
  storage_locations: number;
  pickup_locations: number;
  is_account_verified: number;
  business_id: number;
  id_proof: string;
  notification_limits: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  banners: Array<Banner>;
}

export interface sellerListResponse {
  status: number;
  total: number;
  data: Array<sellerListDetails>;
}

export interface sellerListDetails {
  id: number;
  type: string;
  user_id: number;
  shop_name: string;
  email: string;
  phone: number;
  phone_code: number;
  profile_photo: string;
  banner_photo: string;
  shop_url: string;
  shop_title: string;
  shop_body: string;
  storage_locations: number;
  pickup_locations: number;
  is_account_verified: number;
  is_account_verified_time: Date;
  business_id: number;
  id_proof: string;
  description: number;
  notification_limits: number;
  bank_account: string;
  bank_name: string;
  account_holder_name: string;
  deduction: number;
  product_highlight: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  products_count: number;
  slug: string;
}

export interface changeSeller {
  business_id: number;
}
@Injectable({
  providedIn: 'root',
})
export class SellerStore {
  constructor(private httpClient: HttpClient) {}

  async sellerSignUp(params: SellerSignUp): Promise<SellerSignUp> {
    const url = `${backendUrl}seller/seller`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<SellerSignUp>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async verifyMobile(params: VerifyMobile): Promise<VerifyMobile> {
    const url = `${backendUrl}seller/verify-mobile`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<VerifyMobile>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async verifyOtp(params: VerifyOtp): Promise<VerifyOtp> {
    const url = `${backendUrl}seller/verify-mobile`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<VerifyOtp>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getSellerDetail(payloadId): Promise<sellerResponse> {
    const url = `${backendUrl}seller/seller/${payloadId}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<sellerResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async sellerChange(params: changeSeller): Promise<SellerSignUp> {
    const url = `${backendUrl}seller/accountchange`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<SellerSignUp>(url, params, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async scanOrder(id: string = ''): Promise<SellerSignUp> {
    const url = `${backendUrl}seller/scan-order/${id}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<SellerSignUp>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getSellerList(params): Promise<sellerListResponse> {
    const url = `${backendUrl}seller`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<sellerListResponse>(url, {
        params: params,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
}
